module.exports = __webpack_public_path__ + "img/20_98.33b96187.png";